
export enum InspectionStatusEnum{
    OPEN = 'OPEN',
    INITIATED = 'INITIATED',
    PASS = 'PASS',
    FAIL = 'FAIL'
}